var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4737 3H0.526316C0.386728 3 0.252858 3.05268 0.154154 3.14645C0.0554511 3.24021 0 3.36739 0 3.5C0 3.63261 0.0554511 3.75979 0.154154 3.85355C0.252858 3.94732 0.386728 4 0.526316 4H19.4737C19.6133 4 19.7471 3.94732 19.8458 3.85355C19.9445 3.75979 20 3.63261 20 3.5C20 3.36739 19.9445 3.24021 19.8458 3.14645C19.7471 3.05268 19.6133 3 19.4737 3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3684 6H2.6316C2.49201 6 2.35814 6.05268 2.25944 6.14645C2.16074 6.24021 2.10529 6.36739 2.10529 6.5C2.10529 6.63261 2.16074 6.75979 2.25944 6.85355C2.35814 6.94732 2.49201 7 2.6316 7H17.3684C17.508 7 17.6419 6.94732 17.7406 6.85355C17.8393 6.75979 17.8948 6.63261 17.8948 6.5C17.8948 6.36739 17.8393 6.24021 17.7406 6.14645C17.6419 6.05268 17.508 6 17.3684 6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2631 9H4.73683C4.59724 9 4.46337 9.05268 4.36466 9.14645C4.26596 9.24021 4.21051 9.36739 4.21051 9.5C4.21051 9.63261 4.26596 9.75979 4.36466 9.85355C4.46337 9.94732 4.59724 10 4.73683 10H15.2631C15.4027 10 15.5366 9.94732 15.6353 9.85355C15.734 9.75979 15.7895 9.63261 15.7895 9.5C15.7895 9.36739 15.734 9.24021 15.6353 9.14645C15.5366 9.05268 15.4027 9 15.2631 9Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1579 12H6.84211C6.70252 12 6.56865 12.0527 6.46995 12.1464C6.37125 12.2402 6.3158 12.3674 6.3158 12.5C6.3158 12.6326 6.37125 12.7598 6.46995 12.8536C6.56865 12.9473 6.70252 13 6.84211 13H13.1579C13.2975 13 13.4314 12.9473 13.5301 12.8536C13.6288 12.7598 13.6842 12.6326 13.6842 12.5C13.6842 12.3674 13.6288 12.2402 13.5301 12.1464C13.4314 12.0527 13.2975 12 13.1579 12Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0527 15H8.9474C8.80781 15 8.67394 15.0527 8.57524 15.1464C8.47653 15.2402 8.42108 15.3674 8.42108 15.5C8.42108 15.6326 8.47653 15.7598 8.57524 15.8536C8.67394 15.9473 8.80781 16 8.9474 16H11.0527C11.1922 16 11.3261 15.9473 11.4248 15.8536C11.5235 15.7598 11.579 15.6326 11.579 15.5C11.579 15.3674 11.5235 15.2402 11.4248 15.1464C11.3261 15.0527 11.1922 15 11.0527 15Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.bebe57d992256757e1fca2983e213f91.svg";
export { ForwardRef as ReactComponent };